// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_cx-0";
export var fileCarousel = "_cx-2";
export var removeFileButton = "_cx-1";